// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Address_wrapper__20dmM","icon":"Address_icon__1pIhf","protocol":"Address_protocol__3bdCe"};